import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import ContactViewVue from '../views/ContactView.vue';
import HomeView from '../views/HomeView.vue';
import BlogIndexView from '../views/BlogIndexView.vue';
import BlogPostView from '../views/BlogPostView.vue';
const routes: RouteRecordRaw[] = [
    {
        path: '/',
        component: HomeView,
        meta: { transition: 'fade' }
    },
    {
        path: '/contacts',
        component: ContactViewVue,
        meta: { transition: 'fade' }
    },
    {
        path: '/posts',
        component: BlogIndexView,
        meta: { transition: 'fade' }
    },
    {
        path: '/posts/:slug',
        component: BlogPostView,
        meta: { transition: 'fade' }
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/'
    },
];
const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;